<template>
  <div class="college-banner">
    <table-list
      title="Banner列表"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="bannerList"
      :columns="columns(this)"
      :operates="operates(this)"
      :btns="btns(this)"
      row-key="id"
      :options="{ operatesWidth: 120 }"
      :pager="pager"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>
<script>
const btns = _this => [
  {
    label: '添加banner',
    method: _this.handleAdd,
    type: 'primary',
  },
]

const searchForm = _this => [
  {
    label: 'Banner名称',
    prop: 'name',
  },
  {
    label: 'Banner位置',
    type: 'select',
    prop: 'mark',
    children: _this.positionList.map(item => ({
      value: item.key,
      label: item.value,
    })),
  },
  {
    label: '有效时间',
    type: 'picker',
    prop: 'timeRange',
  },
  {
    label: '上线/下线',
    type: 'select',
    prop: 'status',
    children: [
      { value: true, label: '上线' },
      { value: false, label: '下线' },
    ],
  },
  {
    label: '排序',
    type: 'select',
    prop: 'sort',
    children: [
      { value: 1, label: '按时间排序' },
      { value: 2, label: '按权重排序' },
    ],
  },
]

const columns = _this => [
  {
    prop: 'id',
    label: '编号',
    minWidth: 100,
  },
  {
    prop: 'name',
    label: 'Banner名称',
    minWidth: 200,
  },
  {
    prop: 'marks',
    label: 'banner位置',
    minWidth: 200,
  },
  {
    prop: 'weight',
    label: '权重',
    minWidth: 100,
  },
  {
    label: 'Banner图片',
    minWidth: 150,
    render: (h, { row }) => {
      return [
        row.imgUrl
          ? h('img', {
              domProps: { src: row.imgUrl },
              style: 'height: 50px;width:100px',
            })
          : null,
      ]
    },
  },
  {
    label: 'banner时间',
    minWidth: 250,
    render: (h, { row }) => {
      return [
        h('div', { class: 'time-info' }, [
          h('div', row.startTime ? '开始时间：' + row.startTime : ''),
          h('div', row.endTime ? '结束时间：' + row.endTime : ''),
        ]),
      ]
    },
  },
  {
    label: '上线/下线',
    minWidth: 120,
    render: (h, { row }) => {
      return [
        h('el-switch', {
          props: { value: row.status, activeValue: true, inactiveValue: false },
          on: {
            change: v => {
              _this.handleStatusChange(v, row)
            },
          },
        }),
      ]
    },
  },
]

const operates = _this => [
  {
    label: '编辑',
    method: _this.handleEdit,
  },
  {
    label: '删除',
    method: _this.handleDelete,
  },
]

import TableList from '@/components/TableList'
import to from 'await-to'
import {
  bannerPlatformFilter,
  bannerList,
  bannerListDelete,
  bannerStatusUpdate,
} from '@/api/system'
export default {
  name: 'CollegeBanner',
  components: {
    TableList,
  },
  data() {
    return {
      btns,
      searchForm,
      columns,
      operates,
      loading: false,
      bannerList: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      selectBanners: [],
      queryParams: {},
      positionList: [],
    }
  },
  mounted() {
    this.getPositionList()
    this.getBannerList()
  },
  methods: {
    async getPositionList() {
      const [res, err] = await to(bannerPlatformFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.positionList = res.data
    },
    async getBannerList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(bannerList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.bannerList = res.data.list
      this.pager.total = res.data.total
    },
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      if (queryParams.timeRange && queryParams.timeRange.length !== 0) {
        this.queryParams.startTime = queryParams.timeRange[0]
        this.queryParams.endTime = queryParams.timeRange[1].split(' ')[0] + ' 23:59:59'
      } else {
        this.queryParams.startTime = ''
        this.queryParams.endTime = ''
      }
      this.getBannerList()
    },
    handleAdd() {
      this.$router.push('/college/banner/add')
    },
    handleEdit(row) {
      this.$router.push(`banner/edit/${row.id}`)
    },
    async handleDelete(row) {
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(bannerListDelete({ id: row.id }))
          if (err) return this.$message.warning(err.msg)
          this.$message({ message: '删除成功', type: 'success' })
          this.getBannerList()
        })
        .catch(() => {})
    },
    async handleStatusChange(v, row) {
      const [, err] = await to(bannerStatusUpdate({ id: row.id, status: v }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('操作成功')
      this.getBannerList()
    },
    handleSelectionChange(val) {
      this.selectBanners = val
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getBannerList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getBannerList()
    },
  },
}
</script>
<style lang="scss" scoped>
.college-banner {
  .banner-img {
    width: 100px;
    height: 60px;
    background-color: #f5f5f5;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .time-info {
    display: flex;
    flex-direction: column;
    line-height: 1.6;
    font-size: 12px;
    color: #606266;
  }
}
</style>
